import React, { useState } from "react"
import { DISCOUNT_RATE } from "~/data/constants/DiscountRate"
import { ID } from "~/models/Identification"
import { PlanType } from "~/models/Plan"
import { CsvProduct } from "~/models/Product"
import { Select } from "~/components/atoms/Select"
import { SimpleHelpButton } from "~/components/molecules/SimpleHelpButton"
import { Modal } from "react-bootstrap"
import { ButtonParts } from "~/components/atoms/ButtonParts"

interface Props {
  data?: ID,
  onChange?: (data: `${PlanType}` | null) => void,
}

export function PlanSelect(props: Props) {
  const { data, onChange } = props
  const plans = DISCOUNT_RATE
  const product = { modalType: 2 } as CsvProduct

  const [show, showSate] = useState<boolean>(false)

  const modalChange = () => {
    showSate(!show);
  }

  return (
    <>
      <div className="peyment-plan">
        <div className="peyment-plan__description">
          <label>お得な長期契約も選べます。</label>
          <SimpleHelpButton data={product} name="about-long-term-contracts" />
        </div>
        <div className="peyment-plan__select">
          <Select dataSource={plans.map(item => ({ label: item.label || item.title, value: item.id }))} selected={data}
            onChange={onChange} className={"form-control"} action={modalChange} />
        </div>
      </div>
      <Modal className={"modal"} show={show} onHide={modalChange}>
        <Modal.Header>
          <span className="info-icon"></span>
          <div className="modal-title">確認</div>
          <ButtonParts className="close" action={modalChange}>
            <span aria-hidden="true">&times;</span></ButtonParts>
        </Modal.Header>
        <Modal.Body>
          選択された契約の料金に変更されます。
        </Modal.Body>
        <Modal.Footer>
          <ButtonParts className={"btn btn-success"} action={modalChange}>OK</ButtonParts>
        </Modal.Footer>
      </Modal>
    </>
  )
}
